import { render, staticRenderFns } from "./ArticleManage.vue?vue&type=template&id=6ac2f85a&scoped=true"
import script from "./ArticleManage.vue?vue&type=script&lang=js"
export * from "./ArticleManage.vue?vue&type=script&lang=js"
import style0 from "./ArticleManage.vue?vue&type=style&index=0&id=6ac2f85a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac2f85a",
  null
  
)

export default component.exports